import { BORDER_RADIUS, PAD_MEDIUM } from 'providers/designSystem';
export const Form = ({ onSubmit, children }) => {
    return (
        <form
            onSubmit={onSubmit}
            style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: `${PAD_MEDIUM}`,
                padding: `${PAD_MEDIUM}`,
                borderRadius: `${BORDER_RADIUS}`,
            }}
        >
            {children}
        </form>
    );
};
